import { jsx as _jsx } from "react/jsx-runtime";
export const CodeSandboxEmbed = ({ contentInfo }) => {
    return (_jsx("iframe", { allow: "accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking", loading: "lazy", sandbox: "allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts", src: `${contentInfo.url}?embed=1`, style: {
            border: 'none',
            borderRadius: 6,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
            height: 600,
            width: '100%',
        } }));
};
//# sourceMappingURL=CodeSandboxEmbed.js.map